import { isCivilDate, parseWireDay, toCivilDate } from '@mfw/common';
import { isValid } from 'date-fns';

import type {
  ApiCorpOrganization,
  UiCorpOrganization,
} from '../../schemas/corpOrganizations.schema';

function toCivilDay(value?: null | string) {
  if (!value) return null;
  // Contract dates stay civil 'yyyy-MM-dd' strings in the UI domain; a
  // legacy cached instant normalizes to the browser-local day once here.
  if (isCivilDate(value)) return value;
  const parsed = parseWireDay(value);
  return isValid(parsed) ? toCivilDate(parsed) : null;
}

/**
 * Maps a corp organization from Api to match the UI schema.
 */
export function mapCorpOrganizationFromApi(
  apiCorpOrganization: ApiCorpOrganization,
): UiCorpOrganization {
  return {
    id: apiCorpOrganization?.id ?? '',
    codesTotal: apiCorpOrganization?.codesTotal ?? 0,
    codesUsed: apiCorpOrganization?.codesUsed ?? 0,
    contactEmail: apiCorpOrganization?.contactEmail ?? '',
    contactPerson: apiCorpOrganization?.contactPerson ?? '',
    contractEndDate: toCivilDay(apiCorpOrganization?.contractEndDate),
    contractStartDate: toCivilDay(apiCorpOrganization?.contractStartDate),
    name: apiCorpOrganization?.name ?? '',
    status: apiCorpOrganization?.status ?? 'ACTIVE',
    theme: apiCorpOrganization?.theme ?? null,
    logoName: apiCorpOrganization?.logoName ?? null,
    logoUrl: apiCorpOrganization?.logoUrl ?? null,
  };
}
